import { DEFAULT_COLOR_SCHEMES } from '../constants/common';

const extractRawState = (colorSchemes, colors) => {
  const currentSchemes = {};

  Object.entries(colorSchemes).forEach(
    ([id, { computedRules: _, basePalette: __, variableOverrides: overrides, ...scheme }]) => {
      const entry = {};
      if (!(id in DEFAULT_COLOR_SCHEMES)) {
        Object.assign(entry, scheme);
      }
      if (Object.keys(overrides).length) {
        entry.variableOverrides = { ...overrides };
      }
      if (Object.keys(entry).length) {
        currentSchemes[id] = entry;
      }
    }
  );

  return {
    colors: { ...colors },
    schemes: currentSchemes,
  };
};

export default extractRawState;
